import type { PopoverProps } from '@mui/material';
import { Typography } from '@mui/material';

import { BodyContainer, BodyItemContainer, Container, IconContainer, StyledPopover, TopContainer, TopLeftContainer, WrapperContainer } from './styled';
import TxSelectButton from './TxSelectButton';
import IconButton from '../IconButton';

import { ReactComponent as Close32Icon } from 'src/assets/svg/Close32.svg';

type DelegateTxSelectionPopoverProps = Omit<PopoverProps, 'children'> & {
  onClickUnstake: (isClicked: boolean) => void;
  onClickRedelegate: (isClicked: boolean) => void;
  onClickClaim: (isClicked: boolean) => void;
};

export default function DelegateTxSelectionPopover({
  onClickUnstake,
  onClickRedelegate,
  onClickClaim,
  // TODO : Compounding
  // onClickCompounding,
  onClose,
  ...remainder
}: DelegateTxSelectionPopoverProps) {
  return (
    <WrapperContainer data-is-open={remainder.open}>
      <StyledPopover onClose={onClose} {...remainder}>
        <Container>
          <TopContainer>
            <TopLeftContainer>
              <Typography variant="h2">Select Transaction</Typography>
            </TopLeftContainer>
            <IconButton
              onClick={() => {
                onClose?.({}, 'backdropClick');
              }}
            >
              <IconContainer>
                <Close32Icon />
              </IconContainer>
            </IconButton>
          </TopContainer>
          <BodyContainer>
            <BodyItemContainer>
              <TxSelectButton
                title="Unstake"
                subtitle="Withdraw staked tokens"
                onClick={(isClicked) => {
                  onClickUnstake(isClicked);
                }}
              />

              <TxSelectButton
                title="Switch Validator"
                subtitle="Change the validator to stake with"
                onClick={(isClicked) => {
                  onClickRedelegate(isClicked);
                }}
              />

              <TxSelectButton
                title="Claim Rewards"
                subtitle="Claim the rewards in USDC and DYDX"
                onClick={(isClicked) => {
                  onClickClaim(isClicked);
                }}
              />

              {/* <TxSelectButton
                title="Compounding"
                subtitle="You can re-staking reward tokens."
                onClick={(isClicked) => {
                  onClickCompounding(isClicked);
                }}
              /> */}
            </BodyItemContainer>
          </BodyContainer>
        </Container>
      </StyledPopover>
    </WrapperContainer>
  );
}
